export default __webpack_public_path__ + "static/media/undraw_not_found_60pq.2d4c8a5e.png";